import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { HttpClientService } from '../http-client/http-client.service';
import { Service } from '../service';
import { ExamCall } from '../../models/exam-calls/exam-call';

@Injectable()
export class ExamCallService extends Service {

    constructor(private http: HttpClientService) {
        super();
    }

    public getAll(): Observable<ExamCall[]> {
        const url = 'examcalls/all';
        return this.http.get(url).map(response => {
            const r = response.json();
            return r.Result;
        }).catch(this.handleError);
    }

    public getBySchoolYear(schoolYearId: number): Observable<ExamCall[]> {
        const url = 'examcalls/byschoolyear/' + schoolYearId;
        return this.http.get(url).map(response => {
            const r = response.json();
            return r.Result;
        }).catch(this.handleError);
    }

    public add(examCall: ExamCall): Observable<any> {
        const url = 'examcalls/add';
        return this.http.post(url, examCall).map(response => response.json())
            .catch(this.handleError);
    }

    public edit(examCall: ExamCall): Observable<any> {
        const url = 'examcalls/edit';
        return this.http.post(url, examCall).map(response => response.json())
            .catch(this.handleError);
    }

    public delete(id: number): Observable<any> {
        const url = 'examcalls/delete/' + id;
        return this.http.delete(url).map(response => response.json())
            .catch(this.handleError);
    }

    public downloadReports(examCallIds: number[], shiftId?: number): Observable<Blob> {
        let url = 'examcalls/DownloadReports';
        if (shiftId) {
            url += `?shiftId=${shiftId}`;
        }
        // enviar el array (no string) y forzar headers + responseType Blob
        const headers = new Headers({
            'Content-Type': 'application/json; charset=utf-8',
            'Accept': 'application/pdf'
        });
        const options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
        return this.http.post(url, examCallIds, options)
            .map(response => response.blob())
            .catch(this.handleError);
    }

    public getBulkEditData(schoolYearId: number): Observable<any> {
        const url = `examcalls/GetBulkEditData/${schoolYearId}`;
        return this.http.get(url).map(response => response.json())
            .catch(this.handleError);
    }

    public saveBulkEdit(data: any): Observable<any> {
        const url = 'examcalls/SaveBulkEdit';
        return this.http.post(url, data).map(response => response.json())
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/exam-call/exam-call.service.ts